import React from "react";
import { Route, Routes } from "react-router-dom";
import SignInSSO from "../SignInSSO";
import AuthLayout from "../layout/AuthLayout";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/ui/login" element={<SignInSSO />} />
      <Route path="/ui/*" element={<AuthLayout />} />
      {/* <Route exact path="/" element={<CustomRedirect />} /> */}
    </Routes>
  );
};

export default AppRouter;
